import { render, staticRenderFns } from "./mo-month-year-selector-wrapper.html?vue&type=template&id=32ab69b5&external"
import script from "./mo-month-year-selector-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-month-year-selector-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ab69b5')) {
      api.createRecord('32ab69b5', component.options)
    } else {
      api.reload('32ab69b5', component.options)
    }
    module.hot.accept("./mo-month-year-selector-wrapper.html?vue&type=template&id=32ab69b5&external", function () {
      api.rerender('32ab69b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-month-year-selector-wrapper/mo-month-year-selector-wrapper.vue"
export default component.exports